/** @type {import('./index').NetworkConfig} */
const reddit = {
  name: 'Reddit',
  sort: 7,
  baseUrl: 'https://www.reddit.com/user/',
  domains: ['reddit.com'],
  supported: false,
  color: '#FF4500',
  hasVideoContent: false,
  supportsEmbed: false,
  requiresReferrer: false,
};

export default reddit;
